// import request from '@/utils/request'
import { get, post,put,remove } from '@/utils/http.js'
// 查询角色列表

export const listRole = (data) => get('/system/role/list',data);
export const getRole = (roleId) => get('/system/role/'+roleId);
export const addRole = (data) => post('/system/role',data);
export const updateRole = (data) => put('/system/role',data);
export const dataScope = (data) => put('/system/role/dataScope',data);
export const changeRoleStatus = (data) => put('/system/role/changeStatus',data);
export const delRole = (roleId) => remove('/system/role/' + roleId);
export const exportRole = (data) => get('/system/role/export',data);

// 查询角色列表
// export function listRole(query) {
//   return request({
//     url: '/system/role/list',
//     method: 'get',
//     params: query
//   })
// }

// 查询角色详细
// export function getRole(roleId) {
//   return request({
//     url: '/system/role/' + roleId,
//     method: 'get'
//   })
// }

// 新增角色
// export function addRole(data) {
//   return request({
//     url: '/system/role',
//     method: 'post',
//     data: data
//   })
// }

// 修改角色
// export function updateRole(data) {
//   return request({
//     url: '/system/role',
//     method: 'put',
//     data: data
//   })
// }

// 角色数据权限
// export function dataScope(data) {
//   return request({
//     url: '/system/role/dataScope',
//     method: 'put',
//     data: data
//   })
// }

// 角色状态修改
// export function changeRoleStatus(roleId, status) {
//   const data = {
//     roleId,
//     status
//   }
//   return request({
//     url: '/system/role/changeStatus',
//     method: 'put',
//     data: data
//   })
// }

// 删除角色
// export function delRole(roleId) {
//   return request({
//     url: '/system/role/' + roleId,
//     method: 'delete'
//   })
// }

// 导出角色
// export function exportRole(query) {
//   return request({
//     url: '/system/role/export',
//     method: 'get',
//     params: query
//   })
// }